import { render, staticRenderFns } from "./CreateModuleTemplate.vue?vue&type=template&id=5b39c7ed&scoped=true"
import script from "./CreateModuleTemplate.vue?vue&type=script&lang=js"
export * from "./CreateModuleTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateModuleTemplate.vue?vue&type=style&index=0&id=5b39c7ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39c7ed",
  null
  
)

export default component.exports